import { useQuery } from '@tanstack/react-query'

import { getWorkspacesFromDataAccessRequests } from 'services/data-access-requests'
import {
  DataAccessRequestQueryOptions,
  withDataAccessRequestsEnabled
} from 'services/data-access-requests/hooks/withDataAccessRequestsEnabled'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { GetDataAccessRequestFilterWorkspacesResponse } from 'services/data-access-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetWorkspacesFromDataAccessRequests = (
  options?: DataAccessRequestQueryOptions<GetDataAccessRequestFilterWorkspacesResponse, ApiErrorResponse>
) => {
  const { enabled: enabledOption, ...restOptions } = options ?? {}

  return useQuery<GetDataAccessRequestFilterWorkspacesResponse, ApiErrorResponse>({
    queryKey: DataAccessRequestQueryKeys.FilterWorkspaces(),
    queryFn: ({ signal }) => getWorkspacesFromDataAccessRequests({ signal }),
    enabled: withDataAccessRequestsEnabled(enabledOption ?? true),
    ...restOptions
  })
}
